import { PERMISSIONS } from '../../constants'
import list from './CouponDisallow'

export default {
  list,
  name: 'unredeem-coupon',
  permissions: [PERMISSIONS.ADMIN],
}
